function D10Icon() {
  return (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12.596 2.067l.107.068 9.883 7.154a1 1 0 01.407.691l.007.12v4.14a1 1 0 01-.324.737l-.093.075L12.7 22.15a1 1 0 01-1.038.079l-.12-.073-10.117-7.104a1 1 0 01-.418-.698L1 14.234v-4.128a1 1 0 01.328-.74l.094-.076L11.54 2.129a1 1 0 011.057-.062zm-.488 2.217L3 10.55v3.236L12.109 20 21 13.798v-3.26l-8.892-6.254zm2.746 3.858c.527 0 .96.065 1.298.193.338.128.614.296.828.501.214.206.382.422.505.65.122.226.221.491.296.794A7.33 7.33 0 0118 12.084c0 1.404-.24 2.431-.721 3.082-.48.651-1.308.976-2.483.976-.659 0-1.191-.103-1.597-.311a2.574 2.574 0 01-.999-.913c-.189-.285-.335-.674-.44-1.169a7.897 7.897 0 01-.158-1.638c0-1.47.268-2.5.804-3.087.536-.588 1.352-.882 2.448-.882zm-4.368 0v7.868h-2.2v-5.155l-.265.19a6.26 6.26 0 01-.769.459c-.333.165-.75.324-1.252.475v-1.763l.27-.09c.612-.217 1.097-.47 1.455-.76.41-.33.73-.738.961-1.224h1.8zm4.294 1.43c-.36 0-.62.18-.78.541-.16.361-.24 1.029-.24 2.003 0 .985.088 1.658.264 2.018.176.361.432.541.766.541.221 0 .412-.076.574-.23.162-.152.282-.394.358-.725.077-.33.115-.846.115-1.546 0-1.027-.088-1.718-.264-2.071-.177-.354-.44-.53-.793-.53z" />
    </svg>
  );
}

export default D10Icon;
